(function () {
  "use strict";

  var MAX_FILE_SIZE = 5 * 1024 * 1024;
  var MAX_COMBINED_SIZE = 20 * 1024 * 1024;
  var STEP_LABELS = ["About You", "Study Choice", "Documents", "Review"];

  var DEFAULT_ACADEMIC_DOCUMENTS = [
    { key: "otherAcademicCertificate", label: "Qualification certificate / diploma", hint: "Upload the certificate, diploma or latest official result." },
    { key: "otherAcademicTranscript", label: "Academic transcript / mark sheet", hint: "Upload the official transcript, mark sheet or result record." }
  ];

  var ACADEMIC_DOCUMENT_RULES = {
    "O levels. (In A2 taking composite)": [
      { key: "previousSecondaryCertificate", label: "O Level / IGCSE result or certificate", hint: "Completed O Level / IGCSE result statement or certificate." },
      { key: "currentStudyTranscript", label: "Current A Level school transcript / predicted grades", hint: "Latest school transcript, predicted grades or statement of entry." }
    ],
    "In AS (completed O levels)": [
      { key: "previousSecondaryCertificate", label: "O Level / IGCSE result or certificate", hint: "Completed O Level / IGCSE result statement or certificate." },
      { key: "currentStudyTranscript", label: "Current AS Level school transcript", hint: "Latest AS Level school transcript, registration or result evidence." }
    ],
    "AS Levels. (Currently in A2)": [
      { key: "previousSecondaryCertificate", label: "O Level / IGCSE result or certificate", hint: "Completed O Level / IGCSE result statement or certificate." },
      { key: "upperSecondaryTranscript", label: "AS Level result", hint: "Official AS Level result statement." },
      { key: "currentStudyTranscript", label: "Current A2 transcript / predicted grades", hint: "Latest A2 school transcript or predicted grades." }
    ],
    "A levels Complete": [
      { key: "previousSecondaryCertificate", label: "O Level / IGCSE result or certificate", hint: "Completed O Level / IGCSE result statement or certificate." },
      { key: "upperSecondaryCertificate", label: "A Level result or certificate", hint: "Final A Level result statement or certificate." }
    ],
    "BTEC LEVEL 3 Complete": [
      { key: "vocationalCertificate", label: "BTEC Level 3 diploma / certificate", hint: "Final BTEC Level 3 diploma or certificate." },
      { key: "vocationalTranscript", label: "BTEC Level 3 transcript / unit results", hint: "Official unit transcript or result record." }
    ],
    "HND Complete": [
      { key: "degreeTranscript", label: "HND transcript", hint: "Upload the official HND transcript or detailed academic record." },
      { key: "degreeCertificate", label: "HND diploma / certificate", hint: "Upload the final HND diploma, award or certificate." }
    ],
    "Inter 2nd year": [
      { key: "previousSecondaryCertificate", label: "Matric / SSC certificate", hint: "Completed Matric / SSC certificate or official result." },
      { key: "previousSecondaryTranscript", label: "Matric / SSC mark sheet", hint: "Official Matric / SSC mark sheet." },
      { key: "currentStudyTranscript", label: "Intermediate / HSSC / FSc latest transcript", hint: "Latest available college transcript or official result." },
      { key: "upperSecondaryTranscript", label: "Intermediate / HSSC / FSc mark sheet", hint: "Latest available mark sheet, including first-year results if final results are pending." }
    ],
    "Inter/FSC Complete": [
      { key: "previousSecondaryCertificate", label: "Matric / SSC certificate", hint: "Completed Matric / SSC certificate or official result." },
      { key: "previousSecondaryTranscript", label: "Matric / SSC mark sheet", hint: "Official Matric / SSC mark sheet." },
      { key: "upperSecondaryCertificate", label: "Intermediate / HSSC / FSc certificate", hint: "Completed Intermediate / HSSC / FSc certificate or official result." },
      { key: "upperSecondaryTranscript", label: "Intermediate / HSSC / FSc mark sheet", hint: "Official Intermediate / HSSC / FSc mark sheet." }
    ],
    "DAE Complete": [
      { key: "previousSecondaryCertificate", label: "Matric / SSC certificate", hint: "Completed Matric / SSC certificate or official result." },
      { key: "previousSecondaryTranscript", label: "Matric / SSC mark sheet", hint: "Official Matric / SSC mark sheet." },
      { key: "vocationalCertificate", label: "DAE diploma / certificate", hint: "Final DAE diploma or certificate." },
      { key: "vocationalTranscript", label: "DAE transcript / mark sheets", hint: "Official DAE transcript or consolidated mark sheets." }
    ],
    "IB final year": [
      { key: "currentStudyTranscript", label: "Latest IB transcript / predicted grades", hint: "Latest official IB transcript or predicted grades." },
      { key: "currentStudyEvidence", label: "IB candidate / enrollment evidence", hint: "School letter, candidate statement or equivalent current-study evidence." }
    ],
    "IB complete": [
      { key: "upperSecondaryTranscript", label: "IB transcript / results", hint: "Official IB transcript or final result statement." },
      { key: "upperSecondaryCertificate", label: "IB Diploma / certificate", hint: "Final IB Diploma or completion certificate." }
    ],
    "American/GED final year": [
      { key: "currentStudyTranscript", label: "Latest high school transcript / GED progress record", hint: "Latest official high school transcript or GED progress record." },
      { key: "currentStudyEvidence", label: "Expected graduation / enrollment evidence", hint: "School letter, enrollment record or expected graduation evidence." }
    ],
    "American high school/GED complete": [
      { key: "upperSecondaryTranscript", label: "High school transcript / GED score report", hint: "Official high school transcript or GED score report." },
      { key: "upperSecondaryCertificate", label: "High school diploma / GED certificate", hint: "Final high school diploma or GED certificate." }
    ],
    "Bachelors final year": [
      { key: "degreeTranscript", label: "Bachelor's transcript", hint: "Upload the latest official transcript from your bachelor's degree." },
      { key: "currentStudyEvidence", label: "Enrollment / expected graduation letter", hint: "Upload current enrollment evidence or an expected graduation / completion letter because the degree certificate has not been issued yet." }
    ],
    "Bachelors complete": [
      { key: "degreeTranscript", label: "Bachelor's transcript", hint: "Upload the official transcript from your bachelor's degree." },
      { key: "degreeCertificate", label: "Bachelor's degree certificate", hint: "Upload the final degree certificate or provisional degree certificate." }
    ],
    "Masters Complete": [
      { key: "degreeTranscript", label: "Master's transcript", hint: "Upload the official transcript from your master's degree." },
      { key: "degreeCertificate", label: "Master's degree certificate", hint: "Upload the final degree certificate or provisional degree certificate." }
    ],
    "Others": DEFAULT_ACADEMIC_DOCUMENTS
  };

  function clean(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }

  function escapeHtml(value) {
    return clean(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function unique(values) {
    var seen = new Set();
    return values.filter(function (value) {
      var key = clean(value);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function initialize(root) {
    if (root.getAttribute("data-tsa-initialized") === "true") return;
    root.setAttribute("data-tsa-initialized", "true");

    var apiBaseUrl = clean(root.getAttribute("data-api-base-url")).replace(/\/$/, "");
    var uploadWorkerUrl = clean(root.getAttribute("data-upload-worker-url")).replace(/\/$/, "");
    var routeParams = new URLSearchParams(window.location.search);
    var incomingSource = clean(routeParams.get("source")).toLowerCase();
    var incomingTrack = clean(routeParams.get("track")).toLowerCase();
    var incomingIntake = clean(routeParams.get("intake"));
    var hasIncomingContext =
      Boolean(incomingSource || incomingTrack || incomingIntake) ||
      routeParams.has("program") ||
      routeParams.has("programs");
    var navigationEntry =
      window.performance && typeof window.performance.getEntriesByType === "function"
        ? window.performance.getEntriesByType("navigation")[0]
        : null;
    var isReload = Boolean(navigationEntry && navigationEntry.type === "reload");
    var storedContext = null;

    try {
      storedContext = JSON.parse(sessionStorage.getItem("tsapp_v3_context") || "null");
    } catch (error) {}

    var canRestoreContext =
      !hasIncomingContext &&
      isReload &&
      storedContext &&
      typeof storedContext === "object";

    var track =
      incomingTrack === "medicine" ||
      incomingSource === "study-medicine" ||
      (canRestoreContext && clean(storedContext.track).toLowerCase() === "medicine") ||
      (!hasIncomingContext && !canRestoreContext && clean(root.getAttribute("data-track")).toLowerCase() === "medicine")
        ? "medicine"
        : "general";
    var defaultSource = clean(root.getAttribute("data-default-source")).toLowerCase() || "home";
    var previewMode = clean(root.getAttribute("data-preview-mode")).toLowerCase() === "true";
    var documentsTestMode =
      clean(root.getAttribute("data-documents-test-mode")).toLowerCase() === "true";

    var activeFormScope = documentsTestMode
      ? root.querySelector(".tsa-v3__docs-test")
      : root.querySelector(".tsa-v3__workspace");
    var form = activeFormScope
      ? activeFormScope.querySelector("[data-tsa-form]")
      : root.querySelector("[data-tsa-form]");
    var panels = Array.from(root.querySelectorAll("[data-tsa-panel]"));
    var progress = Array.from(root.querySelectorAll("[data-tsa-progress]"));
    var mobileProgress = root.querySelector("[data-tsa-mobile-progress]");
    var errorBox = root.querySelector("[data-tsa-error]");
    var loadingBox = root.querySelector("[data-tsa-loading]");
    var previewNotice = root.querySelector("[data-tsa-preview-notice]");
    var sourceNote = root.querySelector("[data-tsa-source-note]");
    var backButton = root.querySelector("[data-tsa-back]");
    var nextButton = root.querySelector("[data-tsa-next]");
    var submitButton = root.querySelector("[data-tsa-submit]");
    var previewComplete = root.querySelector("[data-tsa-preview-complete]");
    var previewAgain = root.querySelector("[data-tsa-preview-again]");
    var sourceInput = root.querySelector("[data-tsa-source]");
    var trackInput = root.querySelector("[data-tsa-track]");
    var phoneCodeSelect = root.querySelector("[data-tsa-phone-code]");
    var phoneLocalInput = root.querySelector("[data-tsa-phone-local]");
    var phoneInput = root.querySelector("[data-tsa-phone]");
    var selectedInput = root.querySelector("[data-tsa-selected-input]");
    var selectedList = root.querySelector("[data-tsa-selected-list]");
    var selectedCount = root.querySelector("[data-tsa-selected-count]");
    var programResults = root.querySelector("[data-tsa-program-results]");
    var programPagination = root.querySelector("[data-tsa-program-pagination]");
    var programCount = root.querySelector("[data-tsa-program-count]");
    var programTitle = root.querySelector("[data-tsa-program-title]");
    var degreeSelect = root.querySelector("[data-tsa-degree]");
    var majorSelect = root.querySelector("[data-tsa-major]");
    var intakeSelect = root.querySelector("[data-tsa-intake]");
    var degreeField = root.querySelector("[data-tsa-degree-field]");
    var majorField = root.querySelector("[data-tsa-major-field]");
    var intakeField = root.querySelector("[data-tsa-intake-field]");
    var intakeNote = root.querySelector("[data-tsa-intake-note]");
    var qualificationSelect = activeFormScope
      ? activeFormScope.querySelector("[data-tsa-qualification]")
      : root.querySelector("[data-tsa-qualification]");
    var academicDocumentsHost = activeFormScope
      ? activeFormScope.querySelector("[data-tsa-academic-documents]")
      : root.querySelector("[data-tsa-academic-documents]");
    var findProgramsButton = root.querySelector("[data-tsa-find-programs]");
    var generalDiscovery = root.querySelector("[data-tsa-general-discovery]");
    var medicineTools = root.querySelector("[data-tsa-medicine-tools]");
    var medicineSearch = root.querySelector("[data-tsa-medicine-search]");
    var disciplineButtons = Array.from(root.querySelectorAll("[data-tsa-discipline]"));
    var addProgramButton = root.querySelector("[data-tsa-add-program]");
    var studyHeading = root.querySelector("[data-tsa-study-heading]");
    var studyCopy = root.querySelector("[data-tsa-study-copy]");
    var reviewHost = root.querySelector("[data-tsa-review]");
    var headerBadge = root.querySelector("[data-tsa-header-badge]");
    var headerHeading = root.querySelector("[data-tsa-header-heading]");
    var headerCopy = root.querySelector("[data-tsa-header-copy]");
    var applicationHeader = root.querySelector(".tsa-v3__header");
    var progressShell = root.querySelector(".tsa-v3__progress");
    var confirmation = root.querySelector("[data-tsa-confirmation]");
    var confirmationReference = root.querySelector("[data-tsa-confirmation-reference]");
    var confirmationName = root.querySelector("[data-tsa-confirmation-name]");
    var confirmationEmail = root.querySelector("[data-tsa-confirmation-email]");
    var confirmationDate = root.querySelector("[data-tsa-confirmation-date]");
    var confirmationPrograms = root.querySelector("[data-tsa-confirmation-programs]");
    var copyReferenceButton = root.querySelector("[data-tsa-copy-reference]");

    var currentStep = 1;
    var recommendations = [];
    var medicinePrograms = [];
    var selectedPrograms = [];
    var activeDiscipline = "";
    var currentProgramPage = 1;
    var lastProgramResults = [];
    var PROGRAMS_PER_PAGE = 6;
    var uploadedReceiptCache = new Map();
    var source = resolveSource();
    var draftKey = "tsapp_v3_draft_" + track + "_" + source;
    var submissionKey = loadSubmissionKey();

    function loadSubmissionKey() {
      var storageKey = draftKey + "_submission_key";
      var existing = "";
      try {
        existing = clean(sessionStorage.getItem(storageKey));
      } catch (error) {}
      if (existing) return existing;

      var generated =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : "tsa-" + Date.now() + "-" + Math.random().toString(36).slice(2, 14);

      try {
        sessionStorage.setItem(storageKey, generated);
      } catch (error) {}
      return generated;
    }

    if (documentsTestMode) {
      if (qualificationSelect) {
        qualificationSelect.addEventListener("change", function () {
          renderAcademicDocuments();
          updateFileStatuses();
        });
      }

      if (form) {
        form.addEventListener("change", function (event) {
          var target = event.target;
          if (target && target.type === "file") updateFileStatus(target);
        });
      }

      renderAcademicDocuments();
      updateFileStatuses();
      return;
    }

    persistApplicationContext();
    cleanApplicationUrl();

    if (sourceInput) sourceInput.value = source;
    if (trackInput) trackInput.value = track;
    if (previewNotice) previewNotice.hidden = !previewMode;

    bindEvents();

    if (restoreConfirmation()) return;

    restoreDraft();
    bindPhoneField();
    syncInternationalPhone();
    renderAcademicDocuments();
    configureEntryMode();
    updateStep();
    updateFileStatuses();
    loadApplicationOptions();

    if (source === "catalog") {
      if (queryProgramIds().length) {
        hydrateProgramShortlist();
      } else if (!selectedPrograms.length) {
        if (track === "medicine") loadMedicinePrograms();
        else loadGeneralFilters();
      }
    } else if (track === "medicine") {
      loadMedicinePrograms();
    } else {
      loadGeneralFilters();
    }

    function syncInternationalPhone() {
      if (!phoneInput || !phoneLocalInput) return "";

      var raw = clean(phoneLocalInput.value);
      var normalized = "";

      if (/^\+/.test(raw)) {
        var internationalDigits = raw.replace(/\D/g, "");
        if (internationalDigits.length >= 8 && internationalDigits.length <= 15) {
          normalized = "+" + internationalDigits;
        }
      } else if (/^00/.test(raw)) {
        var zeroPrefixedDigits = raw.replace(/\D/g, "").replace(/^00/, "");
        if (zeroPrefixedDigits.length >= 8 && zeroPrefixedDigits.length <= 15) {
          normalized = "+" + zeroPrefixedDigits;
        }
      } else {
        var codeDigits = clean(phoneCodeSelect && phoneCodeSelect.value).replace(/\D/g, "");
        var localDigits = raw.replace(/\D/g, "").replace(/^0+/, "");
        var combined = codeDigits + localDigits;

        if (codeDigits && localDigits && combined.length >= 8 && combined.length <= 15) {
          normalized = "+" + combined;
        }
      }

      phoneInput.value = normalized;
      return normalized;
    }

    function bindPhoneField() {
      if (!phoneLocalInput || !phoneInput) return;

      phoneLocalInput.addEventListener("input", syncInternationalPhone);
      phoneLocalInput.addEventListener("change", syncInternationalPhone);

      if (phoneCodeSelect) {
        phoneCodeSelect.addEventListener("change", syncInternationalPhone);
      }

      syncInternationalPhone();
    }

    function formatConfirmationDate(value) {
      var date = value ? new Date(value) : new Date();
      if (Number.isNaN(date.getTime())) date = new Date();

      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
    }

    function shopifyPreviewParams() {
      var current = new URL(window.location.href);
      var preview = new URLSearchParams();

      ["preview_theme_id", "_ab", "_fd", "_sc"].forEach(function (key) {
        if (current.searchParams.has(key)) {
          preview.set(key, current.searchParams.get(key));
        }
      });

      return preview;
    }

    function confirmationUrl() {
      var params = shopifyPreviewParams();
      params.set("submitted", "1");
      return window.location.pathname + "?" + params.toString();
    }

    function persistApplicationContext() {
      try {
        sessionStorage.setItem(
          "tsapp_v3_context",
          JSON.stringify({ source: source, track: track })
        );
      } catch (error) {}
    }

    function cleanApplicationUrl() {
      if (clean(routeParams.get("submitted")) === "1") return;

      var current = new URL(window.location.href);
      var changed = false;

      ["source", "track", "intake", "program", "programs", "reference"].forEach(function (key) {
        if (current.searchParams.has(key)) {
          current.searchParams.delete(key);
          changed = true;
        }
      });

      if (!changed) return;

      var next =
        current.pathname +
        (current.searchParams.toString() ? "?" + current.searchParams.toString() : "") +
        current.hash;

      window.history.replaceState(
        { tsApplyContext: true, source: source, track: track },
        "",
        next
      );
    }

    function showConfirmation(data, updateUrl) {
      var reference = clean(data && data.reference).toUpperCase();
      if (!reference) return false;

      var fullName = [clean(data.firstName), clean(data.lastName)].filter(Boolean).join(" ");
      var email = clean(data.email);
      var programs = Array.isArray(data.programs) ? data.programs : [];

      if (applicationHeader) applicationHeader.hidden = true;
      if (progressShell) progressShell.hidden = true;
      if (mobileProgress) mobileProgress.hidden = true;
      if (previewNotice) previewNotice.hidden = true;
      if (sourceNote) sourceNote.hidden = true;
      if (errorBox) errorBox.hidden = true;
      if (loadingBox) loadingBox.hidden = true;
      if (form) form.hidden = true;
      if (previewComplete) previewComplete.hidden = true;
      if (confirmation) confirmation.hidden = false;

      if (confirmationReference) confirmationReference.textContent = reference;
      if (confirmationName) confirmationName.textContent = fullName || "Application submitted";
      if (confirmationEmail) confirmationEmail.textContent = email || "Keep your reference number safe.";
      if (confirmationDate) confirmationDate.textContent = formatConfirmationDate(data.submittedAt);

      if (confirmationPrograms) {
        if (programs.length) {
          confirmationPrograms.innerHTML = programs.map(function (program, index) {
            var title = clean(program && (program.title || program.displayTitle)) || "Selected program";
            var university = clean(program && program.university);

            return "<article class='tsa-v3__confirmation-program'>" +
              "<span>" + (index + 1) + "</span>" +
              "<div><strong>" + escapeHtml(title) + "</strong>" +
              (university ? "<small>" + escapeHtml(university) + "</small>" : "") +
              "</div></article>";
          }).join("");
        } else {
          confirmationPrograms.innerHTML =
            "<p class='tsa-v3__confirmation-empty'>Your selected programs have been saved with the application.</p>";
        }
      }

      if (updateUrl) {
        window.history.replaceState(
          { tsApplySubmitted: true, reference: reference },
          "",
          confirmationUrl()
        );
      }

      window.scrollTo({
        top: Math.max(0, root.getBoundingClientRect().top + window.scrollY - 90),
        behavior: updateUrl ? "smooth" : "auto"
      });

      return true;
    }

    function previewConfirmationData() {
      var storedPrograms = [];

      try {
        storedPrograms = readStoredPrograms();
      } catch (error) {}

      return {
        reference: "TS-PREVIEW-2026",
        email: "student@example.com",
        firstName: "Preview",
        lastName: "Student",
        submittedAt: new Date().toISOString(),
        status: "Submitted",
        programs: (storedPrograms || []).map(function (program) {
          return {
            title: clean(program.displayTitle || program.title || "Selected program"),
            university: clean(program.university)
          };
        })
      };
    }

    function restoreConfirmation() {
      if (clean(routeParams.get("submitted")) !== "1") return false;

      var stored = null;
      try {
        stored = JSON.parse(sessionStorage.getItem("tsapp_application_confirmation") || "null");
      } catch (error) {}

      if (stored && clean(stored.reference)) {
        return showConfirmation(stored, false);
      }

      if (previewMode) {
        return showConfirmation(previewConfirmationData(), false);
      }

      window.history.replaceState({}, "", window.location.pathname);
      return false;
    }

    function resolveSource() {
      if (incomingSource === "catalog" || incomingSource === "programs") {
        return "catalog";
      }
      if (incomingSource === "study-medicine") {
        return "study-medicine";
      }

      if (canRestoreContext) {
        var restoredSource = clean(storedContext.source).toLowerCase();
        if (restoredSource === "catalog" || restoredSource === "programs") {
          return "catalog";
        }
        if (restoredSource === "study-medicine") return "study-medicine";
        if (restoredSource === "home") return "home";
      }

      if (defaultSource === "catalog" || defaultSource === "programs") {
        return "catalog";
      }
      if (defaultSource === "study-medicine") {
        return "study-medicine";
      }

      return "home";
    }

    function endpoint(path) {
      return apiBaseUrl + path;
    }

    async function readResponse(response) {
      var text = await response.text();
      var data = {};
      try {
        data = text ? JSON.parse(text) : {};
      } catch (error) {
        data = {};
      }
      if (!response.ok || data.ok === false) {
        throw new Error(data.error || data.message || "Request failed.");
      }
      return data;
    }

    async function postJson(path, body) {
      var target = endpoint(path);

      if (String(path || "").indexOf("/api/programs/") === 0) {
        target =
          apiBaseUrl +
          String(path).replace(/^\/api\/programs\//, "/api/v3/programs/");
      }

      var response = await fetch(target, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body || {})
      });
      return readResponse(response);
    }

    function showError(message) {
      if (!errorBox) return;
      var text = clean(message);
      errorBox.textContent = text;
      errorBox.hidden = !text;
      if (text) errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    function showLoading(message) {
      if (!loadingBox) return;
      var text = clean(message);
      loadingBox.textContent = text;
      loadingBox.hidden = !text;
    }

    function setDiscoveryFieldMode(mode) {
      var shortlistMode = mode === "shortlist";
      var medicineMode = mode === "medicine";

      if (generalDiscovery) generalDiscovery.hidden = false;
      if (degreeField) degreeField.hidden = shortlistMode || medicineMode;
      if (majorField) majorField.hidden = shortlistMode || medicineMode;
      if (intakeField) intakeField.hidden = false;
      if (findProgramsButton) findProgramsButton.hidden = shortlistMode || medicineMode;

      disableGeneralSelectors(shortlistMode || medicineMode);
    }

    function commonSelectedIntakes() {
      if (!selectedPrograms.length) return [];

      var common = null;
      selectedPrograms.forEach(function (program) {
        var values = Array.isArray(program && program.intakes)
          ? program.intakes.map(clean).filter(Boolean)
          : [];
        var set = new Set(values);

        if (common === null) {
          common = set;
          return;
        }

        common = new Set(Array.from(common).filter(function (value) {
          return set.has(value);
        }));
      });

      return common ? Array.from(common) : [];
    }

    function configureEntryMode() {
      var ids = queryProgramIds();

      if (source === "catalog") {
        // Fresh catalogue IDs override any previous shortlist. On refresh the
        // cleaned URL restores the saved shortlist instead.
        if (ids.length) {
          selectedPrograms = [];
        } else if (!selectedPrograms.length) {
          selectedPrograms = readStoredPrograms();
        }

        syncSelected();

        if (selectedPrograms.length || ids.length) {
          if (headerBadge) {
            headerBadge.textContent =
              track === "medicine"
                ? "Your selected medical programs"
                : "Your selected programs";
          }
          if (headerHeading) {
            headerHeading.textContent =
              track === "medicine"
                ? "Complete Your Medicine in Türkiye Application"
                : "Complete Your University Application";
          }
          if (headerCopy) {
            headerCopy.textContent =
              "We carried your catalogue shortlist into the application. Complete your profile and documents, then review the programs before submitting.";
          }

          if (medicineTools) medicineTools.hidden = true;
          setDiscoveryFieldMode("shortlist");
          if (addProgramButton) addProgramButton.hidden = false;
          if (studyHeading) studyHeading.textContent = "Review your shortlist";
          if (studyCopy) {
            studyCopy.textContent =
              "Your saved programs are already here. Remove anything you no longer want, or add another program.";
          }
          updateShortlistNote();
          return;
        }
      }

      if (track === "medicine") {
        if (headerBadge) headerBadge.textContent = "Medical application";
        if (headerHeading) headerHeading.textContent = "Your Medicine in Türkiye Application";
        if (headerCopy) headerCopy.textContent = "Complete your profile, choose eligible Medicine, Dentistry or Pharmacy programs, upload your documents and review everything before you send.";

        if (medicineTools) medicineTools.hidden = false;
        setDiscoveryFieldMode("medicine");
        if (addProgramButton) addProgramButton.hidden = true;
        if (studyHeading) studyHeading.textContent = "Choose your medical program";
        if (studyCopy) studyCopy.textContent = "Compare eligible undergraduate Medicine, Dentistry and Pharmacy options, then add the programs you want us to review.";
        if (sourceNote) {
          sourceNote.innerHTML = "";
          sourceNote.hidden = true;
        }
        return;
      }

      if (headerBadge) headerBadge.textContent = "TS Apply";
      if (headerHeading) headerHeading.textContent = "Start Your University Application";
      if (headerCopy) headerCopy.textContent = "Tell us what you want to study, complete your profile, upload your documents and choose suitable programs in one guided application.";

      if (medicineTools) medicineTools.hidden = true;
      setDiscoveryFieldMode("general");
      if (addProgramButton) addProgramButton.hidden = true;
      if (sourceNote) sourceNote.hidden = true;
    }

    function updateShortlistNote(unavailableCount) {
      if (!sourceNote || source !== "catalog") return;

      if (selectedPrograms.length) {
        sourceNote.innerHTML =
          "<strong>Your shortlist is ready.</strong> " +
          selectedPrograms.length +
          (selectedPrograms.length === 1 ? " program was" : " programs were") +
          " carried into the application." +
          (unavailableCount ? " " + unavailableCount + " unavailable selection" + (unavailableCount === 1 ? " was" : "s were") + " skipped." : "");
      } else {
        sourceNote.innerHTML = "<strong>No selected programs found.</strong> Add a program below before continuing.";
      }

      sourceNote.hidden = false;
    }

    function queryProgramIds() {
      var values = routeParams.getAll("program");
      routeParams.getAll("programs").forEach(function (group) {
        String(group || "").split(",").forEach(function (value) {
          values.push(value);
        });
      });

      var seen = new Set();
      return values.map(clean).filter(function (id) {
        if (!/^\d+$/.test(id) || seen.has(id)) return false;
        seen.add(id);
        return true;
      }).slice(0, 30);
    }

    async function hydrateProgramShortlist() {
      var ids = queryProgramIds();

      if (!ids.length) {
        if (!selectedPrograms.length) enableTrackDiscovery();
        return;
      }

      try {
        showLoading("Loading your selected programs...");

        var data = await postJson("/api/programs/search", {
          track: track,
          ids: ids
        });

        var all = normalizePrograms(data.results || []);
        var byId = new Map();

        all.forEach(function (program) {
          byId.set(clean(program.id), program);
        });

        var storedSelections = readStoredPrograms();
        var storedById = new Map();
        storedSelections.forEach(function (program) {
          storedById.set(clean(program && program.id), program);
        });

        var canonical = ids.map(function (id) {
          var program = byId.get(id);
          if (!program) return null;

          var availableIntakes = Array.isArray(program.intakes)
            ? program.intakes.map(clean).filter(Boolean)
            : [];
          var stored = storedById.get(id);
          var storedIntake = clean(stored && stored.applicationIntake);
          var preferredIntake = "";

          if (incomingIntake && availableIntakes.indexOf(incomingIntake) >= 0) {
            preferredIntake = incomingIntake;
          } else if (storedIntake && availableIntakes.indexOf(storedIntake) >= 0) {
            preferredIntake = storedIntake;
          } else if (availableIntakes.length === 1) {
            preferredIntake = availableIntakes[0];
          }

          var hydrated = {};
          Object.keys(program || {}).forEach(function (key) {
            hydrated[key] = program[key];
          });
          if (preferredIntake) hydrated.applicationIntake = preferredIntake;
          return hydrated;
        }).filter(Boolean);

        if (canonical.length) {
          selectedPrograms = normalizePrograms(canonical);
          syncSelected();

          try {
            localStorage.setItem("tsapp_selected_programs", JSON.stringify(selectedPrograms));
            localStorage.setItem("tsapp_from_program_finder", "true");
          } catch (error) {}
        }

        updateShortlistNote(Math.max(0, ids.length - canonical.length));

        if (selectedPrograms.length) {
          await loadApplicationOptions();
        } else {
          enableTrackDiscovery();
        }
      } catch (error) {
        console.warn("TS Apply could not hydrate program IDs from the URL.", error);
        updateShortlistNote(0);
        if (!selectedPrograms.length) enableTrackDiscovery();
      } finally {
        showLoading("");
      }
    }

    function readStoredPrograms() {
      try {
        var multiple = JSON.parse(localStorage.getItem("tsapp_selected_programs") || "[]");
        if (Array.isArray(multiple) && multiple.length) return normalizePrograms(multiple);
      } catch (error) {
        console.warn("TS Apply could not read saved programs.", error);
      }
      try {
        var single = JSON.parse(localStorage.getItem("tsapp_selected_program") || "null");
        return single ? normalizePrograms([single]) : [];
      } catch (error) {
        return [];
      }
    }

    function normalizePrograms(items) {
      var seen = new Set();
      return (items || []).filter(function (item) {
        if (!item || item.id == null) return false;
        var id = clean(item.id);
        var applicationIntake = clean(item.applicationIntake);
        var key = id + "::" + applicationIntake;
        if (!id || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    function disableGeneralSelectors(disabled) {
      [degreeSelect, majorSelect].forEach(function (select) {
        if (!select) return;
        select.disabled = disabled;
        select.required = !disabled;
      });
    }

    function enableGeneralDiscovery() {
      if (medicineTools) medicineTools.hidden = true;
      setDiscoveryFieldMode("general");
      if (addProgramButton) addProgramButton.hidden = true;
      loadGeneralFilters();
    }

    function enableTrackDiscovery() {
      if (track === "medicine") {
        if (medicineTools) medicineTools.hidden = false;
        setDiscoveryFieldMode("medicine");
        if (addProgramButton) addProgramButton.hidden = true;

        if (medicinePrograms.length) renderMedicinePrograms(true);
        else loadMedicinePrograms();
        return;
      }

      enableGeneralDiscovery();
    }

    function bindEvents() {
      backButton.addEventListener("click", function () {
        showError("");
        if (currentStep > 1) setStep(currentStep - 1);
      });

      nextButton.addEventListener("click", function () {
        showError("");
        if (!validateStep(currentStep)) return;
        if (currentStep < 4) setStep(currentStep + 1);
      });

      submitButton.addEventListener("click", submitApplication);

      if (copyReferenceButton) {
        copyReferenceButton.addEventListener("click", async function () {
          var reference = clean(confirmationReference && confirmationReference.textContent);
          if (!reference || reference === "—") return;

          try {
            await navigator.clipboard.writeText(reference);
            copyReferenceButton.textContent = "Copied";
            window.setTimeout(function () {
              copyReferenceButton.textContent = "Copy";
            }, 1600);
          } catch (error) {
            copyReferenceButton.textContent = "Copy manually";
          }
        });
      }

      if (previewAgain) {
        previewAgain.addEventListener("click", function () {
          previewComplete.hidden = true;
          form.hidden = false;
          currentStep = 1;
          updateStep();
        });
      }

      form.addEventListener("input", function (event) {
        var target = event.target;
        if (target && target.classList) target.classList.remove("is-invalid");
        saveDraft();
      });

      form.addEventListener("change", function (event) {
        var target = event.target;
        if (target && target.classList) target.classList.remove("is-invalid");
        if (target && target.type === "file") updateFileStatus(target);
        if (target && target.name === "email") {
          uploadedReceiptCache.clear();
        }
        if (target === qualificationSelect) {
          renderAcademicDocuments();
          updateFileStatuses();
        }
        if (target === intakeSelect) {
          var chosenIntake = clean(intakeSelect && intakeSelect.value);

          if (source === "catalog" && selectedPrograms.length && chosenIntake) {
            selectedPrograms = selectedPrograms.map(function (program) {
              var availableIntakes = Array.isArray(program && program.intakes)
                ? program.intakes.map(clean).filter(Boolean)
                : [];

              if (availableIntakes.indexOf(chosenIntake) < 0) return program;

              var updated = {};
              Object.keys(program || {}).forEach(function (key) {
                updated[key] = program[key];
              });
              updated.applicationIntake = chosenIntake;
              return updated;
            });
          }

          syncSelected();

          if (track === "medicine") {
            loadMedicinePrograms();
          } else if (degreeSelect.value && majorSelect.value && intakeSelect.value) {
            loadGeneralPrograms();
          } else if (lastProgramResults.length) {
            renderPrograms(lastProgramResults, false);
          }
          if (currentStep === 4) renderReview();
        }
        saveDraft();
      });

      degreeSelect.addEventListener("change", function () {
        majorSelect.value = "";
        loadGeneralFilters();
      });

      majorSelect.addEventListener("change", function () {
        loadGeneralFilters();
      });

      if (findProgramsButton) {
        findProgramsButton.addEventListener("click", loadGeneralPrograms);
      }

      if (addProgramButton) {
        addProgramButton.addEventListener("click", enableTrackDiscovery);
      }

      disciplineButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          activeDiscipline = clean(button.getAttribute("data-tsa-discipline"));
          disciplineButtons.forEach(function (item) {
            item.classList.toggle("is-active", item === button);
          });
          renderMedicinePrograms(true);
        });
      });

      if (medicineSearch) {
        medicineSearch.addEventListener("input", function () {
          renderMedicinePrograms(true);
        });
      }

      root.addEventListener("click", function (event) {
        var pageButton = event.target.closest("[data-tsa-page]");
        if (pageButton) {
          var action = clean(pageButton.getAttribute("data-tsa-page"));
          var totalPages = Math.max(1, Math.ceil(lastProgramResults.length / PROGRAMS_PER_PAGE));

          if (action === "prev") currentProgramPage -= 1;
          else if (action === "next") currentProgramPage += 1;
          else currentProgramPage = Number(action) || currentProgramPage;

          currentProgramPage = Math.max(1, Math.min(totalPages, currentProgramPage));
          renderPrograms(lastProgramResults, false);

          if (programTitle) {
            programTitle.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return;
        }

        var toggle = event.target.closest("[data-tsa-program-toggle]");
        if (toggle) {
          var id = clean(toggle.getAttribute("data-tsa-program-toggle"));
          var all = recommendations.concat(medicinePrograms).concat(selectedPrograms);
          var program = all.find(function (item) { return clean(item.id) === id; });
          if (program) toggleProgram(program);
          return;
        }

        var remove = event.target.closest("[data-tsa-remove-program]");
        if (remove) {
          removeProgram(clean(remove.getAttribute("data-tsa-remove-program")));
          return;
        }

        var edit = event.target.closest("[data-tsa-edit-step]");
        if (edit) {
          var step = Number(edit.getAttribute("data-tsa-edit-step"));
          if (step >= 1 && step <= 3) setStep(step);
        }
      });
    }

    function academicDocumentsForQualification(value) {
      var qualification = clean(value);
      var rules = ACADEMIC_DOCUMENT_RULES[qualification];

      if (Array.isArray(rules) && rules.length) {
        return rules;
      }

      return qualification ? DEFAULT_ACADEMIC_DOCUMENTS : [];
    }

    function renumberFileRows() {
      Array.from(form.querySelectorAll(".tsa-v3__file")).forEach(function (row, index) {
        var icon = row.querySelector(".tsa-v3__file-icon");
        if (icon) icon.textContent = String(index + 1).padStart(2, "0");
      });
    }

    function renderAcademicDocuments() {
      if (!academicDocumentsHost || !qualificationSelect) return;

      var qualification = clean(qualificationSelect.value);
      var documents = academicDocumentsForQualification(qualification);

      if (!documents.length) {
        academicDocumentsHost.innerHTML =
          "<div class='tsa-v3__academic-placeholder'>Choose your current / highest qualification to see the academic documents required for your application.</div>";
        renumberFileRows();
        return;
      }

      academicDocumentsHost.innerHTML = documents.map(function (documentRule, index) {
        var documentKey = clean(documentRule.key) || ("academicDocument" + (index + 1));
        var fileKey = "academic-" + documentKey;
        var label = clean(documentRule.label) || "Academic document";
        var hint = clean(documentRule.hint) || "Upload the relevant academic document.";

        return "<label class='tsa-v3__file'>" +
          "<input type='file' name='transcript' data-tsa-file-key='" + escapeHtml(fileKey) + "' data-tsa-document-key='" + escapeHtml(documentKey) + "' data-tsa-document-label='" + escapeHtml(label) + "' accept='.pdf,.jpg,.jpeg,.png,.webp,.doc,.docx' required>" +
          "<span class='tsa-v3__file-icon'>00</span>" +
          "<span class='tsa-v3__file-copy'><strong>" + escapeHtml(label) + " *</strong><small data-tsa-file-status='" + escapeHtml(fileKey) + "'>" + escapeHtml(hint) + " · Max 5 MB</small></span>" +
          "<span class='tsa-v3__file-action'>Browse</span>" +
        "</label>";
      }).join("");

      renumberFileRows();
    }

    async function loadApplicationOptions() {
      if (!intakeSelect) return;

      var selected = clean(intakeSelect.value);

      try {
        if (intakeNote) {
          intakeNote.textContent = "Loading available intakes from the program catalogue...";
        }

        var response = await fetch(
          endpoint("/api/application/options") + "?track=" + encodeURIComponent(track),
          {
            method: "GET",
            headers: { "Accept": "application/json" },
            cache: "no-store"
          }
        );
        var data = await readResponse(response);
        var catalogueIntakes = Array.isArray(data.intakes)
          ? data.intakes.map(clean).filter(Boolean)
          : [];

        var intakes =
          source === "catalog" && selectedPrograms.length
            ? commonSelectedIntakes().filter(function (value) {
                return catalogueIntakes.indexOf(value) >= 0;
              })
            : catalogueIntakes.slice();

        intakeSelect.innerHTML = optionHtml(
          intakes,
          "Select preferred intake",
          selected
        );
        intakeSelect.disabled = !intakes.length;

        var preferredIntake = selected;

        if (incomingIntake && intakes.indexOf(incomingIntake) >= 0) {
          preferredIntake = incomingIntake;
        } else if (!preferredIntake && intakes.length === 1) {
          preferredIntake = intakes[0];
        }

        if (preferredIntake && intakes.indexOf(preferredIntake) >= 0) {
          intakeSelect.value = preferredIntake;

          if (source === "catalog" && selectedPrograms.length) {
            selectedPrograms = selectedPrograms.map(function (program) {
              var availableIntakes = Array.isArray(program && program.intakes)
                ? program.intakes.map(clean).filter(Boolean)
                : [];
              if (availableIntakes.indexOf(preferredIntake) < 0) return program;

              var updated = {};
              Object.keys(program || {}).forEach(function (key) {
                updated[key] = program[key];
              });
              updated.applicationIntake = preferredIntake;
              return updated;
            });
            syncSelected();
          }
        }

        if (!intakes.length) {
          if (intakeNote) {
            intakeNote.textContent =
              source === "catalog" && selectedPrograms.length
                ? "Your selected programs do not currently share an available intake."
                : "No program intakes are currently available.";
          }
          showError(
            source === "catalog" && selectedPrograms.length
              ? "Your shortlisted programs do not share an available intake. Please adjust your shortlist."
              : "No program intakes are currently available."
          );
          return;
        }

        if (intakeNote) {
          intakeNote.textContent =
            (source === "catalog" && selectedPrograms.length
              ? "Available for your shortlist · "
              : "From current program tags · ") +
            intakes.length +
            (intakes.length === 1 ? " intake" : " intakes");
        }
      } catch (error) {
        intakeSelect.innerHTML =
          "<option value=''>Program intakes unavailable</option>";
        intakeSelect.disabled = true;
        if (intakeNote) {
          intakeNote.textContent =
            "Could not load intake choices from the program catalogue. Refresh and try again.";
        }
        showError(
          error && error.message
            ? error.message
            : "Could not load program intakes."
        );
      }
    }

    function setStep(step) {
      currentStep = Math.max(1, Math.min(4, step));
      updateStep();
      if (currentStep === 4) renderReview();
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function updateStep() {
      panels.forEach(function (panel) {
        panel.hidden = Number(panel.getAttribute("data-tsa-panel")) !== currentStep;
      });

      progress.forEach(function (item) {
        var number = Number(item.getAttribute("data-tsa-progress"));
        item.classList.toggle("is-active", number === currentStep);
        item.classList.toggle("is-done", number < currentStep);
      });

      mobileProgress.textContent = currentStep + " of 4 · " + STEP_LABELS[currentStep - 1];
      backButton.hidden = currentStep === 1;
      nextButton.hidden = currentStep === 4;
      submitButton.hidden = currentStep !== 4;
    }

    function validateStep(step) {
      var panel = root.querySelector("[data-tsa-panel='" + step + "']");
      if (!panel) return true;

      var controls = Array.from(panel.querySelectorAll("input,select,textarea"))
        .filter(function (control) {
          if (control.disabled || control.type === "hidden") return false;
          if (control.hidden) return false;
          var container = control.closest("[hidden]");
          return !container;
        });

      var firstInvalid = null;
      controls.forEach(function (control) {
        if (!control.checkValidity()) {
          control.classList.add("is-invalid");
          if (!firstInvalid) firstInvalid = control;
        }
      });

      if (step === 2 && !selectedPrograms.length) {
        showError("Select at least one program before continuing.");
        return false;
      }

      if (firstInvalid) {
        showError("Please complete the highlighted required fields.");
        firstInvalid.focus({ preventScroll: true });
        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
        return false;
      }

      return true;
    }

    function optionHtml(values, placeholder, selected) {
      var html = "<option value=''>" + escapeHtml(placeholder) + "</option>";
      (values || []).forEach(function (value) {
        var text = clean(value);
        if (!text) return;
        html += "<option value='" + escapeHtml(text) + "'" + (text === selected ? " selected" : "") + ">" + escapeHtml(text) + "</option>";
      });
      return html;
    }

    async function loadGeneralFilters() {
      if (track === "medicine" || (source === "catalog" && generalDiscovery && generalDiscovery.hidden)) return;

      try {
        showLoading("Loading study options...");
        var degree = clean(degreeSelect.value);
        var major = clean(majorSelect.value);
        var data = await postJson("/api/programs/filters", {
          track: "general",
          excludeMedical: true,
          degreeLevel: degree,
          major: major
        });
        var filters = data.filters || {};

        degreeSelect.innerHTML = optionHtml(filters.degreeLevels || [], "Select degree level", degree);

        if (!degreeSelect.value) {
          majorSelect.innerHTML = optionHtml([], "Select degree level first", "");
          majorSelect.disabled = true;
          return;
        }

        majorSelect.disabled = false;
        majorSelect.innerHTML = optionHtml(filters.majors || [], "Select program", major);
      } catch (error) {
        showError(error.message || "Could not load study options.");
      } finally {
        showLoading("");
      }
    }

    async function loadGeneralPrograms() {
      showError("");
      if (!degreeSelect.value || !majorSelect.value || !intakeSelect.value) {
        showError("Choose a degree level, program and preferred intake first.");
        return;
      }

      try {
        showLoading("Finding matching programs...");
        var data = await postJson("/api/programs/search", {
          track: "general",
          excludeMedical: true,
          degreeLevel: degreeSelect.value,
          major: majorSelect.value,
          intake: intakeSelect.value
        });
        recommendations = normalizePrograms(data.results || []);
        renderPrograms(recommendations, true);
        if (programTitle) programTitle.textContent = "Matching programs";
      } catch (error) {
        showError(error.message || "Could not load matching programs.");
      } finally {
        showLoading("");
      }
    }

    function inferMedicalDiscipline(program) {
      var explicit = clean(program && program.medicalDiscipline);
      if (explicit === "Medicine" || explicit === "Dentistry" || explicit === "Pharmacy") return explicit;

      var text = [
        program && program.displayTitle,
        program && program.title,
        program && Array.isArray(program.majors) ? program.majors.join(" ") : "",
        program && Array.isArray(program.specialities) ? program.specialities.join(" ") : ""
      ].join(" ").toLowerCase();

      if (/\bveterinary\b/.test(text)) return "";
      if (/\bdentistry\b|\bdental medicine\b|\bdental surgery\b|\bbds\b/.test(text)) return "Dentistry";
      if (/\bpharmacy\b|\bpharm\s*d\b|\bdoctor of pharmacy\b/.test(text)) return "Pharmacy";
      if (/\bmedicine\b|\bmbbs\b|\bdoctor of medicine\b/.test(text)) return "Medicine";
      return "";
    }

    function isUndergraduate(program) {
      var degree = Array.isArray(program.degreeLevels) ? program.degreeLevels.join(" ").toLowerCase() : "";
      return !degree || degree.indexOf("bachelor") >= 0 || degree.indexOf("undergraduate") >= 0;
    }

    async function loadMedicinePrograms() {
      try {
        showLoading("Loading medical programs...");
        var data = await postJson("/api/programs/search", {
          track: "medicine",
          degreeLevel: "",
          major: "",
          intake: clean(intakeSelect && intakeSelect.value),
          search: ""
        });

        medicinePrograms = normalizePrograms((data.results || []).filter(function (program) {
          return isUndergraduate(program) && Boolean(inferMedicalDiscipline(program));
        }));

        selectedPrograms = normalizePrograms(selectedPrograms.filter(function (program) {
          var id = clean(program.id);
          return medicinePrograms.some(function (candidate) { return clean(candidate.id) === id; });
        }));

        syncSelected();
        renderMedicinePrograms(true);
      } catch (error) {
        showError(error.message || "Could not load medical programs.");
      } finally {
        showLoading("");
      }
    }

    function renderMedicinePrograms(resetPage) {
      var query = clean(medicineSearch && medicineSearch.value).toLowerCase();
      var filtered = medicinePrograms.filter(function (program) {
        var discipline = inferMedicalDiscipline(program);
        if (activeDiscipline && discipline !== activeDiscipline) return false;
        if (!query) return true;
        var haystack = [
          program.displayTitle,
          program.title,
          program.university,
          Array.isArray(program.majors) ? program.majors.join(" ") : ""
        ].join(" ").toLowerCase();
        return haystack.indexOf(query) >= 0;
      });

      renderPrograms(filtered, Boolean(resetPage));
      if (programTitle) programTitle.textContent = activeDiscipline ? activeDiscipline + " programs" : "Medical programs";
    }

    function renderPrograms(programs, resetPage) {
      var items = programs || [];
      lastProgramResults = items.slice();

      if (resetPage) currentProgramPage = 1;

      var totalPages = Math.max(1, Math.ceil(items.length / PROGRAMS_PER_PAGE));
      currentProgramPage = Math.max(1, Math.min(totalPages, currentProgramPage));

      if (programCount) {
        programCount.textContent = items.length + (items.length === 1 ? " option" : " options");
      }

      if (!items.length) {
        programResults.innerHTML = "<div class='tsa-v3__empty'>No matching programs found. Try another option or search term.</div>";
        renderProgramPagination(0);
        return;
      }

      var startIndex = (currentProgramPage - 1) * PROGRAMS_PER_PAGE;
      var pageItems = items.slice(startIndex, startIndex + PROGRAMS_PER_PAGE);

      programResults.innerHTML = pageItems.map(function (program) {
        var id = clean(program.id);
        var preferredIntake = clean(intakeSelect && intakeSelect.value);
        var selected = selectedPrograms.some(function (item) {
          return clean(item.id) === id &&
            clean(item.applicationIntake) === preferredIntake;
        });
        var image = clean(program.imageUrl);
        var title = clean(program.displayTitle || program.title || "Program");
        var university = clean(program.university);
        var tuition = clean(program.tuitionEstimate);
        var tags = [];
        if (track === "medicine") tags.push(inferMedicalDiscipline(program));
        tags = tags.concat(program.degreeLevels || []);
        if (
          preferredIntake &&
          Array.isArray(program.intakes) &&
          program.intakes.indexOf(preferredIntake) >= 0
        ) {
          tags.push(preferredIntake);
        } else {
          tags = tags.concat(program.intakes || []);
        }
        tags = unique(tags).slice(0, 3);

        var imageHtml = image
          ? "<img src='" + escapeHtml(image) + "' alt='' loading='lazy'>"
          : "<span>TS Apply</span>";

        return "<article class='tsa-v3__program" + (selected ? " is-selected" : "") + "'>" +
          "<div class='tsa-v3__program-image'>" + imageHtml + "</div>" +
          "<div class='tsa-v3__program-body'>" +
            "<h4>" + escapeHtml(title) + "</h4>" +
            "<p>" + escapeHtml(university) + "</p>" +
            "<div class='tsa-v3__program-tags'>" +
              tags.map(function (tag) { return "<span>" + escapeHtml(tag) + "</span>"; }).join("") +
            "</div>" +
            "<div class='tsa-v3__program-footer'>" +
              "<strong>" + escapeHtml(tuition || "Ask advisor") + "</strong>" +
              "<button type='button' data-tsa-program-toggle='" + escapeHtml(id) + "'>" + (selected ? "Selected ✓" : "Add") + "</button>" +
            "</div>" +
          "</div>" +
        "</article>";
      }).join("");

      renderProgramPagination(totalPages);
    }

    function renderProgramPagination(totalPages) {
      if (!programPagination) return;

      if (!totalPages || totalPages <= 1) {
        programPagination.hidden = true;
        programPagination.innerHTML = "";
        return;
      }

      programPagination.hidden = false;

      var pages = [];
      var windowStart = Math.max(1, currentProgramPage - 2);
      var windowEnd = Math.min(totalPages, currentProgramPage + 2);

      if (currentProgramPage <= 3) windowEnd = Math.min(totalPages, 5);
      if (currentProgramPage >= totalPages - 2) windowStart = Math.max(1, totalPages - 4);

      if (windowStart > 1) pages.push(1);
      if (windowStart > 2) pages.push("ellipsis-start");

      for (var page = windowStart; page <= windowEnd; page += 1) {
        pages.push(page);
      }

      if (windowEnd < totalPages - 1) pages.push("ellipsis-end");
      if (windowEnd < totalPages) pages.push(totalPages);

      var pageButtons = pages.map(function (page) {
        if (typeof page !== "number") {
          return "<span class='tsa-v3__pagination-ellipsis' aria-hidden='true'>…</span>";
        }

        return "<button type='button' class='tsa-v3__pagination-page" +
          (page === currentProgramPage ? " is-active" : "") +
          "' data-tsa-page='" + page + "'" +
          (page === currentProgramPage ? " aria-current='page'" : "") +
          ">" + page + "</button>";
      }).join("");

      programPagination.innerHTML =
        "<button type='button' class='tsa-v3__pagination-nav' data-tsa-page='prev'" +
          (currentProgramPage === 1 ? " disabled" : "") +
          ">← Previous</button>" +
        "<div class='tsa-v3__pagination-pages'>" + pageButtons + "</div>" +
        "<span class='tsa-v3__pagination-summary'>Page " + currentProgramPage + " of " + totalPages + "</span>" +
        "<button type='button' class='tsa-v3__pagination-nav' data-tsa-page='next'" +
          (currentProgramPage === totalPages ? " disabled" : "") +
          ">Next →</button>";
    }

    function toggleProgram(program) {
      var id = clean(program.id);
      var applicationIntake = clean(intakeSelect && intakeSelect.value);
      var programIntakes = Array.isArray(program.intakes)
        ? program.intakes.map(clean).filter(Boolean)
        : [];

      if (!applicationIntake) {
        showError("Choose an intake before adding this program.");
        return;
      }

      if (programIntakes.indexOf(applicationIntake) < 0) {
        showError("This program is not available for " + applicationIntake + ".");
        return;
      }

      var selectionKey = id + "::" + applicationIntake;
      var exists = selectedPrograms.some(function (item) {
        return clean(item.id) + "::" + clean(item.applicationIntake) === selectionKey;
      });

      if (exists) {
        selectedPrograms = selectedPrograms.filter(function (item) {
          return clean(item.id) + "::" + clean(item.applicationIntake) !== selectionKey;
        });
      } else {
        var selection = {};
        Object.keys(program || {}).forEach(function (key) {
          selection[key] = program[key];
        });
        selection.applicationIntake = applicationIntake;
        selectedPrograms.push(selection);
      }

      syncSelected();
      if (track === "medicine") renderMedicinePrograms(false);
      else renderPrograms(recommendations, false);
      saveDraft();
    }

    function removeProgram(selectionKey) {
      selectedPrograms = selectedPrograms.filter(function (item) {
        return clean(item.id) + "::" + clean(item.applicationIntake) !== selectionKey;
      });
      syncSelected();
      if (track === "medicine") renderMedicinePrograms(false);
      else renderPrograms(recommendations, false);
      saveDraft();
    }

    function selectedProgramsForApplication() {
      return selectedPrograms.map(function (program) {
        var applicationProgram = {};
        Object.keys(program || {}).forEach(function (key) {
          applicationProgram[key] = program[key];
        });
        return applicationProgram;
      });
    }

    function syncSelected() {
      selectedPrograms = normalizePrograms(selectedPrograms);

      try {
        if (source === "catalog") {
          if (selectedPrograms.length) {
            localStorage.setItem("tsapp_selected_programs", JSON.stringify(selectedPrograms));
          } else {
            localStorage.removeItem("tsapp_selected_programs");
            localStorage.removeItem("tsapp_selected_program");
          }
        }
      } catch (error) {}

      selectedInput.value = JSON.stringify(selectedProgramsForApplication());
      selectedCount.textContent = selectedPrograms.length + (selectedPrograms.length === 1 ? " program" : " programs");

      if (!selectedPrograms.length) {
        selectedList.innerHTML = "<div class='tsa-v3__empty'>No programs selected yet.</div>";
        return;
      }

      selectedList.innerHTML = selectedPrograms.map(function (program) {
        var intakeLabel = clean(program.applicationIntake);
        var selectionKey = clean(program.id) + "::" + intakeLabel;
        var meta = [clean(program.university), intakeLabel].filter(Boolean).join(" · ");

        return "<div class='tsa-v3__selected-item'>" +
          "<strong>" + escapeHtml(program.displayTitle || program.title || "Program") + "</strong>" +
          "<small>" + escapeHtml(meta) + "</small>" +
          "<button type='button' data-tsa-remove-program='" + escapeHtml(selectionKey) + "'>Remove</button>" +
        "</div>";
      }).join("");
    }

    function updateFileStatuses() {
      Array.from(form.querySelectorAll("input[type='file']")).forEach(updateFileStatus);
    }

    function updateFileStatus(input) {
      var fileKey = clean(input.getAttribute("data-tsa-file-key")) || input.name;
      var status =
        (form && form.querySelector("[data-tsa-file-status='" + fileKey + "']")) ||
        root.querySelector("[data-tsa-file-status='" + fileKey + "']");
      var wrapper = input.closest(".tsa-v3__file");
      var file = input.files && input.files[0];

      if (!file) {
        if (wrapper) wrapper.classList.remove("is-ready");
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        input.value = "";
        if (status) status.textContent = "File is too large · Maximum 5 MB";
        if (wrapper) wrapper.classList.remove("is-ready");
        showError("Each document must be 5 MB or smaller.");
        return;
      }

      if (status) status.textContent = file.name + " · " + formatBytes(file.size) + " · Ready";
      if (wrapper) wrapper.classList.add("is-ready");
    }

    function formatBytes(bytes) {
      if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + " KB";
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    }

    function renderReview() {
      var value = function (name) {
        var element = form.elements[name];
        return element ? clean(element.value) : "";
      };

      var personalRows = [
        ["Name", value("firstName") + " " + value("lastName")],
        ["Email", value("email")],
        ["Phone", value("phone")],
        ["Date of birth", value("dateOfBirth")],
        ["Citizenship", value("nationality")],
        ["Residence", value("residence")],
        ["City", value("city")]
      ];

      var academicRows = [
        ["Qualification", value("currentQualification")],
        ["Institution", value("lastInstitutionAttended")],
        ["Grades", value("grades")]
      ];

      var studyRows = [
        ["Application route", source === "catalog" ? "Program catalogue" : "Start application"],
        ["Track", track === "medicine" ? "Medicine / Dentistry / Pharmacy" : "General"],
        ["Browse intake", value("intake")],
        ["Budget", value("budget") ? value("budget") + " " + value("budgetCurrency") : ""],
        ["Lifestyle", value("lifestylePreference")],
        ["Candidate type", value("candidateType")]
      ];

      if (track === "general" && !degreeSelect.disabled) {
        studyRows.push(["Degree level", value("degreeLevel")]);
        studyRows.push(["Program", value("intendedProgram")]);
      }

      var fileRows = Array.from(form.querySelectorAll("input[type='file']")).filter(function (input) {
        return input.files && input.files[0];
      }).map(function (input) {
        var wrapper = input.closest(".tsa-v3__file");
        var label = wrapper && wrapper.querySelector(".tsa-v3__file-copy strong");
        return [label ? clean(label.textContent).replace(/\s*\*\s*$/, "") : input.name, input.files[0].name];
      });

      reviewHost.innerHTML =
        reviewCard("Your details", personalRows, 1, false) +
        reviewCard("Academic background", academicRows, 1, false) +
        reviewCard("Study plan", studyRows, 2, false) +
        "<article class='tsa-v3__review-card'><div class='tsa-v3__review-card-head'><strong>Documents</strong><button type='button' data-tsa-edit-step='3'>Edit</button></div>" +
          "<div class='tsa-v3__review-list'>" +
            fileRows.map(function (row) { return reviewRow(row[0], row[1]); }).join("") +
          "</div></article>" +
        "<article class='tsa-v3__review-card tsa-v3__review-card--full'><div class='tsa-v3__review-card-head'><strong>Selected programs</strong><button type='button' data-tsa-edit-step='2'>Edit</button></div>" +
          selectedPrograms.map(function (program) {
            var applicationIntake = clean(program.applicationIntake);
            var details = escapeHtml(program.university || "");
            if (applicationIntake) details += (details ? " · " : "") + escapeHtml(applicationIntake);
            if (program.tuitionEstimate) details += (details ? " · " : "") + escapeHtml(program.tuitionEstimate);
            return "<div class='tsa-v3__review-program'><strong>" + escapeHtml(program.displayTitle || program.title || "Program") + "</strong><span>" + details + "</span></div>";
          }).join("") +
        "</article>";
    }

    function reviewCard(title, rows, step, full) {
      return "<article class='tsa-v3__review-card" + (full ? " tsa-v3__review-card--full" : "") + "'>" +
        "<div class='tsa-v3__review-card-head'><strong>" + escapeHtml(title) + "</strong><button type='button' data-tsa-edit-step='" + step + "'>Edit</button></div>" +
        "<div class='tsa-v3__review-list'>" + rows.map(function (row) { return reviewRow(row[0], row[1]); }).join("") + "</div></article>";
    }

    function reviewRow(label, value) {
      return "<div class='tsa-v3__review-row'><span>" + escapeHtml(label) + "</span><span>" + escapeHtml(value || "—") + "</span></div>";
    }

    function saveDraft() {
      try {
        var fields = {};
        Array.from(form.elements).forEach(function (element) {
          if (!element.name || element.type === "file" || element.type === "hidden") return;
          if (["degreeLevel", "intendedProgram"].indexOf(element.name) >= 0) return;
          if (element.type === "checkbox") fields[element.name] = element.checked;
          else fields[element.name] = element.value;
        });
        sessionStorage.setItem(draftKey, JSON.stringify({
          fields: fields,
          selectedPrograms: selectedPrograms
        }));
      } catch (error) {
        console.warn("TS Apply could not save the draft.", error);
      }
    }

    function restoreDraft() {
      try {
        var parsed = JSON.parse(sessionStorage.getItem(draftKey) || "null");
        if (!parsed || typeof parsed !== "object") return;

        Object.keys(parsed.fields || {}).forEach(function (name) {
          var element = form.elements[name];
          if (!element || element.type === "file") return;
          if (element.type === "checkbox") element.checked = Boolean(parsed.fields[name]);
          else element.value = parsed.fields[name];
        });

        if (Array.isArray(parsed.selectedPrograms)) {
          selectedPrograms = normalizePrograms(parsed.selectedPrograms);
          syncSelected();
        }
      } catch (error) {
        console.warn("TS Apply could not restore the draft.", error);
      }
    }

    async function uploadDocument(input, email, position, total) {
      var file = input.files && input.files[0];
      if (!file) return "";

      var fileKey = clean(input.getAttribute("data-tsa-file-key")) || input.name;
      var normalizedEmail = clean(email).toLowerCase();
      var cacheKey = [normalizedEmail, fileKey, file.name, file.size, file.lastModified].join("|");
      var cached = uploadedReceiptCache.get(cacheKey);
      if (cached && cached.expiresAt > Date.now()) return cached.receipt;

      showLoading("Uploading document " + position + " of " + total + ": " + file.name);

      var uploadData = new FormData();
      uploadData.set("file", file);
      uploadData.set("fieldName", input.name);
      uploadData.set("email", email);

      if (input.name === "transcript") {
        var documentKey = clean(input.getAttribute("data-tsa-document-key"));
        if (documentKey) uploadData.set("documentKey", documentKey);
      }

      var response = await fetch(uploadWorkerUrl, {
        method: "POST",
        body: uploadData
      });
      var data = await readResponse(response);
      if (!data.receipt) throw new Error("The upload service did not return a signed receipt.");

      uploadedReceiptCache.set(cacheKey, {
        receipt: data.receipt,
        expiresAt: Date.now() + 25 * 60 * 1000
      });

      return data.receipt;
    }

    async function uploadDocuments(email) {
      var inputs = Array.from(form.querySelectorAll("input[type='file']")).filter(function (input) {
        return input.files && input.files[0];
      });
      var total = inputs.reduce(function (sum, input) {
        return sum + input.files[0].size;
      }, 0);

      if (total > MAX_COMBINED_SIZE) {
        throw new Error("Your documents exceed the 20 MB combined upload limit.");
      }

      var receipts = [];
      var academicDocumentKeys = [];

      for (var index = 0; index < inputs.length; index += 1) {
        var input = inputs[index];
        var receipt = await uploadDocument(input, email, index + 1, inputs.length);
        if (!receipt) continue;

        receipts.push(receipt);

        if (input.name === "transcript") {
          var documentKey = clean(input.getAttribute("data-tsa-document-key"));
          if (documentKey) academicDocumentKeys.push(documentKey);
        }
      }

      return {
        receipts: receipts,
        academicDocumentKeys: academicDocumentKeys
      };
    }

    async function revalidateSelectedProgramsBeforeSubmit() {
      var ids = selectedPrograms.map(function (program) {
        return clean(program && program.id);
      }).filter(function (id) {
        return /^\d+$/.test(id);
      });
      var uniqueIds = unique(ids);

      if (!ids.length || ids.length !== selectedPrograms.length) {
        throw new Error("One or more selected programs are invalid. Please review your shortlist and try again.");
      }

      showLoading("Checking that your selected programs are still available...");

      var data = await postJson("/api/programs/search", {
        track: track,
        ids: uniqueIds
      });
      var unavailableIds = Array.isArray(data.unavailableIds)
        ? data.unavailableIds.map(clean).filter(Boolean)
        : [];
      var refreshedPrograms = Array.isArray(data.results) ? data.results : [];

      if (unavailableIds.length || refreshedPrograms.length !== uniqueIds.length) {
        throw new Error("One or more selected programs are no longer available. Please update your shortlist before submitting.");
      }

      var byId = new Map();
      refreshedPrograms.forEach(function (program) {
        byId.set(clean(program.id), program);
      });

      selectedPrograms = selectedPrograms.map(function (selection) {
        var canonical = byId.get(clean(selection.id));
        if (!canonical) return null;

        var applicationIntake = clean(selection.applicationIntake);
        var availableIntakes = Array.isArray(canonical.intakes)
          ? canonical.intakes.map(clean).filter(Boolean)
          : [];

        if (!applicationIntake || availableIntakes.indexOf(applicationIntake) < 0) {
          throw new Error(
            (canonical.displayTitle || canonical.title || "A selected program") +
            " is no longer available for " +
            (applicationIntake || "the selected intake") +
            "."
          );
        }

        var refreshedSelection = {};
        Object.keys(canonical).forEach(function (key) {
          refreshedSelection[key] = canonical[key];
        });
        refreshedSelection.applicationIntake = applicationIntake;
        return refreshedSelection;
      }).filter(Boolean);

      syncSelected();
    }

    async function submitApplication() {
      showError("");
      if (!validateStep(4)) return;

      if (previewMode) {
        var previewData = {
          reference: "TS-PREVIEW-2026",
          email: clean(form.elements.email.value).toLowerCase() || "student@example.com",
          firstName: clean(form.elements.firstName.value) || "Preview",
          lastName: clean(form.elements.lastName.value) || "Student",
          submittedAt: new Date().toISOString(),
          status: "Submitted",
          programs: selectedPrograms.map(function (program) {
            return {
              title: clean(program.displayTitle || program.title || "Selected program"),
              university: clean(program.university)
            };
          })
        };

        try {
          sessionStorage.setItem("tsapp_application_confirmation", JSON.stringify(previewData));
        } catch (error) {}

        showConfirmation(previewData, true);
        return;
      }

      try {
        submitButton.disabled = true;
        submitButton.textContent = "Submitting...";
        selectedInput.value = JSON.stringify(selectedProgramsForApplication());

        await revalidateSelectedProgramsBeforeSubmit();
        selectedInput.value = JSON.stringify(selectedProgramsForApplication());

        var email = clean(form.elements.email.value).toLowerCase();
        var normalizedPhone = syncInternationalPhone();
        if (!normalizedPhone) {
          throw new Error("Enter a valid phone number with a country code.");
        }
        var uploadResult = await uploadDocuments(email);
        var formData = new FormData(form);

        Array.from(form.querySelectorAll("input[type='file']")).forEach(function (input) {
          formData.delete(input.name);
        });
        var primaryProgram = selectedPrograms[0] || {};
        var primaryDegree =
          clean((primaryProgram.degreeLevels || [])[0]) || "Selected program";
        var primaryMajor =
          clean((primaryProgram.majors || [])[0]) ||
          clean(primaryProgram.displayTitle || primaryProgram.title) ||
          "Selected program";
        var primaryIntake =
          clean(primaryProgram.applicationIntake) ||
          clean((primaryProgram.intakes || [])[0]) ||
          "To be confirmed";

        if (!clean(formData.get("degreeLevel"))) {
          formData.set("degreeLevel", primaryDegree);
        }
        if (!clean(formData.get("intendedProgram"))) {
          formData.set("intendedProgram", primaryMajor);
        }
        if (!clean(formData.get("intake"))) {
          formData.set("intake", primaryIntake);
        }

        formData.set("uploadedFileReceipts", JSON.stringify(uploadResult.receipts));
        formData.set("academicDocumentKeys", JSON.stringify(uploadResult.academicDocumentKeys));
        formData.set("selectedPrograms", JSON.stringify(selectedProgramsForApplication()));
        formData.set("submissionKey", submissionKey);
        try {
          var tsaAttr = {};
          try { tsaAttr = JSON.parse(localStorage.getItem("tsa_attribution") || "{}") || {}; } catch (e) {}
          var tsaNow = new URLSearchParams(window.location.search);
          ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","fbclid","gclid"].forEach(function (k) {
            var v = clean(tsaNow.get(k)) || clean(tsaAttr[k]);
            if (v) formData.set(k, v);
          });
          var tsaCookie = function (n) { var m = document.cookie.match(new RegExp("(?:^|; )" + n + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : ""; };
          var tsaFbc = tsaCookie("_fbc") || (formData.get("fbclid") ? "fb.1." + Date.now() + "." + formData.get("fbclid") : "");
          if (tsaFbc) formData.set("fbc", tsaFbc);
          if (tsaCookie("_fbp")) formData.set("fbp", tsaCookie("_fbp"));
          if (tsaAttr.landing_page) formData.set("landingPage", tsaAttr.landing_page);
          if (tsaAttr.referrer) formData.set("referrer", tsaAttr.referrer);
        } catch (e) {}

        showLoading("Saving your application...");
        var response = await fetch(endpoint("/api/application"), {
          method: "POST",
          body: formData
        });
        var data = await readResponse(response);

        if (data.preview) {
          var backendPreviewData = {
            reference: clean(data.reference).toUpperCase() || "TS-PREVIEW-2026",
            email: email || "student@example.com",
            firstName: clean(form.elements.firstName.value) || "Preview",
            lastName: clean(form.elements.lastName.value) || "Student",
            submittedAt: data.submittedAt || new Date().toISOString(),
            status: data.status || "Submitted",
            programs: selectedPrograms.map(function (program) {
              return {
                title: clean(program.displayTitle || program.title || "Selected program"),
                university: clean(program.university)
              };
            })
          };

          try {
            sessionStorage.setItem("tsapp_application_confirmation", JSON.stringify(backendPreviewData));
          } catch (error) {}

          showLoading("");
          showConfirmation(backendPreviewData, true);
          return;
        }

        var reference = clean(data.reference).toUpperCase();
        if (!reference) throw new Error("Application saved, but no reference number was returned.");

        var confirmationData = {
          reference: reference,
          email: email,
          firstName: clean(form.elements.firstName.value),
          lastName: clean(form.elements.lastName.value),
          submittedAt: data.submittedAt || new Date().toISOString(),
          status: data.status || "Submitted",
          programs: selectedPrograms.map(function (program) {
            return {
              title: clean(program.displayTitle || program.title || "Selected program"),
              university: clean(program.university)
            };
          })
        };

        sessionStorage.setItem("tsapp_application_confirmation", JSON.stringify(confirmationData));
        sessionStorage.removeItem(draftKey);
        sessionStorage.removeItem(draftKey + "_submission_key");

        try {
          localStorage.removeItem("tsapp_selected_programs");
          localStorage.removeItem("tsapp_selected_program");
          localStorage.removeItem("tsapp_from_program_finder");
          localStorage.removeItem("tsapp_catalog_selected_all");
          localStorage.removeItem("tsapp_catalog_selected_general");
          localStorage.removeItem("tsapp_catalog_selected_medicine");
        } catch (error) {}

        showLoading("");
        showConfirmation(confirmationData, true);
        window.location.assign(
          (track === "medicine"
            ? "/pages/medicine-application-submission-confirmation"
            : "/pages/application-submission-confirmation") +
          "?ref=" + encodeURIComponent(reference)
        );
      } catch (error) {
        showError(error && error.message ? error.message : "Application submit failed.");
        submitButton.disabled = false;
        submitButton.textContent = "Send application";
      } finally {
        showLoading("");
      }
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-tsa-v3]").forEach(initialize);
  }

  boot(document);

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
